import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "homeaboutwrap"
};
const _hoisted_3 = {
  class: "homeabout"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "bluelabel"
})], -1);
const _hoisted_5 = {
  class: "en"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "bluelabel"
})], -1);
const _hoisted_7 = {
  class: "homenavwrap"
};
const _hoisted_8 = {
  class: "homenav"
};
const _hoisted_9 = ["onMouseover", "onClick"];
const _hoisted_10 = {
  class: "navcover"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "navcon"
};
const _hoisted_13 = {
  class: "navtitle2"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "navmore"
}, [/*#__PURE__*/_createElementVNode("span", null, "更多")], -1);
const _hoisted_16 = {
  class: "navtitle"
};
export default {
  __name: 'home',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const FFdata = reactive({
      isLoad: false,
      listNav: [],
      cNavIndex: 0
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'gen_home',
        msg: ''
      }, res => {
        FFdata.listNav = res.infodata;
        FFdata.isLoad = true;
      });
      proxy.$store.SET_NAVALIAS('');
    };
    const gourl = url => {
      router.push(url);
    };
    const navOver = index => {
      FFdata.cNavIndex = index;
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_ffcontent = _resolveComponent("ffcontent");
      return _unref(FFdata).isLoad ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("dl", null, [_hoisted_4, _createElementVNode("dd", null, [_createVNode(_component_ffcontent, {
        alias: "gen_home_cn"
      })])]), _createElementVNode("dl", _hoisted_5, [_hoisted_6, _createElementVNode("dd", null, [_createVNode(_component_ffcontent, {
        alias: "gen_home_en"
      })])])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listNav, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['homenavitem', index == _unref(FFdata).cNavIndex ? 'cs' : '']),
          onMouseover: $event => navOver(index),
          key: item.id,
          onClick: $event => gourl(item.url)
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1), _createElementVNode("div", {
          class: "editor2",
          innerHTML: item.content
        }, null, 8, _hoisted_14), _hoisted_15])]), _createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1)], 42, _hoisted_9);
      }), 128))])])])) : _createCommentVNode("", true);
    };
  }
};